/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { callabo__models__audit__Device } from './callabo__models__audit__Device';
import type { Geo } from './Geo';

/**
 * 공유 레코드 관련 audit log
 */
export type AuditLogSharedRecord = {
  ts: string;
  workspace_id: number;
  user_id?: number | null;
  system_actor?: boolean | null;
  ip?: string | null;
  device: callabo__models__audit__Device;
  geo?: Geo | null;
  user_agent?: string | null;
  action: AuditLogSharedRecord.action;
  share_id: string;
  record_id?: number | null;
  title?: string | null;
  duration?: string | null;
  expires_at?: string | null;
  before_title?: string | null;
  before_duration?: string | null;
  before_expires_at?: string | null;
  result?: string | null;
  failure_reason?: string | null;
  scope?: string | null;
  /**
   * 하위 클래스에서 구현해야 하는 action type
   */
  readonly action_type: string;
};

export namespace AuditLogSharedRecord {
  export enum action {
    SHARED_RECORD_CREATE = 'shared_record.create',
    SHARED_RECORD_UPDATE = 'shared_record.update',
    SHARED_RECORD_DELETE = 'shared_record.delete',
    SHARED_RECORD_ACCESS = 'shared_record.access',
  }
}
